var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnkh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296 256H251.375C272.5 222 288 181.625 288 144C288 55.625 230.75 0 160 0S32 55.625 32 144C32 181.625 47.5 222 68.625 256H24C10.75 256 0 266.75 0 280V312C0 325.25 10.75 336 24 336H120V488C120 501.25 130.75 512 144 512H176C189.25 512 200 501.25 200 488V336H296C309.25 336 320 325.25 320 312V280C320 266.75 309.25 256 296 256ZM160 80C189.625 80 208 104.5 208 144C208 178.625 180.875 222.125 160 244.875C139.125 222.125 112 178.625 112 144C112 104.5 130.375 80 160 80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnkh);
export default __webpack_public_path__ + "static/media/ankh.226257d840f8e5624c6a292551e0f78a.svg";
export { ForwardRef as ReactComponent };